import { render, staticRenderFns } from "./SecurityCenter.vue?vue&type=template&id=4b4d5a19&"
import script from "./SecurityCenter.vue?vue&type=script&lang=js&"
export * from "./SecurityCenter.vue?vue&type=script&lang=js&"
import style0 from "./SecurityCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports